import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	// ar não recebe as chaves novas (fora de escopo): cai em inglês antes do português.
	fallbackLng: { ar: ["en", "pt"], default: ["pt"] },
	ns: ["translations"],
	resources: messages,
	// React já escapa; sem isto "30/09" vira "30&#x2F;09" nas interpolações.
	interpolation: { escapeValue: false },
});

export { i18n };
